import { useApp } from "../context/AppContext";
import "./ActivityBar.css";
import NavigateTo from "../utils/NavigateTo";


/**
 * ActivityBar — the narrow leftmost icon column in VS Code.
 * Icons: Explorer, Search, Source Control, Theme toggle.
 */
function ActivityBar({
  sidebarOpen,
  setSidebarOpen,
  terminalOpen,
  setTerminalOpen,
}) {
  const { theme, toggleTheme, locale, setLocale, t } = useApp();

  return (
    <div className="activity-bar">
      {/* Top icons */}
      <div className="activity-bar__top">
        {/* Explorer */}
        <button
          className={`activity-btn${sidebarOpen ? " activity-btn--active" : ""}`}
          onClick={() => setSidebarOpen((v) => !v)}
          title="Explorer"
          aria-label="Toggle file explorer"
        >
          <IconFiles />
        </button>

        <button
          className="activity-btn"
          onClick={(e) => NavigateTo(e, "https://github.com/Tommy-BOU")}
          title="GitHub"
          aria-label="Github Link"
        >
          <IconGithub />
        </button>

        <button
          className="activity-btn"
          onClick={(e) => NavigateTo(e, "https://www.linkedin.com/in/tommy-boubaker-82b02381/")}
          title="Linkedin"
          aria-label="Linkedin Link"
        >
          <IconLinkedin />
        </button>
        {/* Search (decorative) */}
        {/* <button className="activity-btn" title="Search" aria-label="Search">
          <IconSearch />
        </button> */}
        {/* Source Control (decorative) */}
        {/* <button className="activity-btn" title="Source Control" aria-label="Source Control">
          <IconGit />
        </button> */}
        {/* Extensions (decorative) */}
        {/* <button className="activity-btn" title="Extensions" aria-label="Extensions">
          <IconExtensions />
        </button> */}
      </div>

      {/* Bottom controls */}
      <div className="activity-bar__bottom">
        {/* Language switcher */}
        <button
          className="activity-btn activity-btn--lang"
          onClick={() => setLocale(locale === "en" ? "fr" : "en")}
          title={locale === "en" ? "Switch to French" : "Passer en anglais"}
          aria-label="Toggle language"
        >
          <span className="activity-lang-label">{locale.toUpperCase()}</span>
        </button>

        {/* Theme toggle */}
        <button
          className="activity-btn"
          onClick={toggleTheme}
          title={
            theme === "dark" ? t("theme.toggle_light") : t("theme.toggle_dark")
          }
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <IconSun /> : <IconMoon />}
        </button>

        {/* Settings (decorative) */}
        {/* <button className="activity-btn" title="Settings" aria-label="Settings">
          <IconSettings />
        </button> */}
      </div>
    </div>
  );
}

/* ── SVG Icons ───────────────────────────────────────────────────── */
const sv = (d, vb = "0 0 24 24") => (
  <svg
    width="22"
    height="22"
    viewBox={vb}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {d}
  </svg>
);

const IconFiles = () =>
  sv(
    <>
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
      <polyline points="13 2 13 9 20 9" />
    </>,
  );

const IconGithub = () =>
  sv(
    <>
      <path
        transform="scale(1.1)"
        d="M13.717 8.88177C12.5881 8.56954 11.4119 8.56954 10.283 8.88177C10.2189 8.89949 10.155 8.91822 10.0912 8.93795L10.0894 8.93853C10.0564 8.94889 10.0205 8.94235 9.99324 8.92103V8.92103C9.95517 8.8914 9.91766 8.8627 9.8807 8.83491C8.69311 7.94193 8.07278 7.98181 7.91927 8.01161V8.01161C7.8946 8.0164 7.87585 8.03481 7.86732 8.05844C7.86516 8.06441 7.86303 8.07038 7.8609 8.07636C7.61639 8.76505 7.57904 9.52813 7.75277 10.2425C7.76289 10.2841 7.77371 10.3255 7.78525 10.3667C7.78601 10.3694 7.78677 10.3721 7.78753 10.3748C7.79754 10.4102 7.7902 10.4483 7.7678 10.4776V10.4776C7.75074 10.4998 7.73394 10.5223 7.71741 10.545C7.24479 11.1939 6.98907 12.0213 7.00036 12.8747C7.00036 16.3399 8.80396 17.1358 10.535 17.3711L10.5708 17.3758C11.5347 17.5199 12.4587 17.511 13.4195 17.3479L13.4438 17.345C15.1832 17.1339 16.9996 16.3587 16.9996 12.8747C17.0109 12.0213 16.7552 11.1939 16.2826 10.545C16.2674 10.5242 16.252 10.5035 16.2364 10.483C16.236 10.4825 16.2356 10.482 16.2352 10.4815C16.211 10.4498 16.203 10.4085 16.2138 10.3701V10.3701C16.2257 10.3277 16.2368 10.2852 16.2471 10.2425C16.421 9.52611 16.3815 8.76076 16.1329 8.07176C16.1313 8.06753 16.1298 8.06331 16.1283 8.05909C16.1195 8.03503 16.1004 8.01628 16.0752 8.01142V8.01142C15.921 7.98164 15.3041 7.94381 14.1193 8.83491C14.0848 8.86084 14.0499 8.88755 14.0144 8.91508V8.91508C13.9824 8.94011 13.9402 8.94762 13.9013 8.93566C13.9005 8.9354 13.8997 8.93514 13.8988 8.93488C13.8384 8.91627 13.7778 8.89857 13.717 8.88177Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        transform="scale(1.1)"
        d="M3 12C3 4.5885 4.5885 3 12 3C19.4115 3 21 4.5885 21 12C21 19.4115 19.4115 21 12 21C4.5885 21 3 19.4115 3 12Z"
      />
    </>,
  );

const IconLinkedin = () =>
  sv(
    <>
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
      <rect x="2" y="9" width="4" height="12"></rect>
      <circle cx="4" cy="4" r="2"></circle>
    </>,
  );

const IconSearch = () =>
  sv(
    <>
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </>,
  );

const IconGit = () =>
  sv(
    <>
      <circle cx="18" cy="18" r="3" />
      <circle cx="6" cy="6" r="3" />
      <circle cx="6" cy="18" r="3" />
      <line x1="6" y1="9" x2="6" y2="15" />
      <path d="M18 9a9 9 0 0 0-9 9" />
    </>,
  );

const IconExtensions = () =>
  sv(
    <>
      <rect x="2" y="7" width="6" height="6" rx="1" />
      <rect x="16" y="7" width="6" height="6" rx="1" />
      <rect x="9" y="2" width="6" height="6" rx="1" />
      <rect x="9" y="16" width="6" height="6" rx="1" />
    </>,
  );

const IconSettings = () =>
  sv(
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </>,
  );

const IconSun = () =>
  sv(
    <>
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </>,
  );

const IconMoon = () =>
  sv(<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />);


export default ActivityBar;
